<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; My Profile</h5>
      </div>
<div id="mainContent" class="container">
  <div class="pt-4 pb-2" *ngIf="user">
    <div class="col-md-12">
      <table class="table table-striped table-bordered table-sm">
        <thead class="">
          <tr>
            <th>Full Name</th>
            <th>User Name</th>
            <!-- <th>Login Access</th> -->
            <th>Employee Type</th>
            <th>Status</th>
            <th>Gender</th>
            <th>Official Email</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{ user.firstName }} {{ user.middleName }} {{ user.lastName }}
            </td>
            <td>{{ user.email }}</td>
            <!-- <td></td> -->
            <td>{{ user.type }}</td>
            <td *ngIf="user.userOfficialDetails != null">
              <span *ngIf="user.userOfficialDetails.profileStatus == 1"
                >Active</span
              >
              <span *ngIf="user.userOfficialDetails.profileStatus == 0"
                >Closed</span
              >
            </td>
            <td *ngIf="user.userOfficialDetails == null"></td>
            <td *ngIf="user.userOfficialDetails != null">
              {{ user.userPersonalDetails.gender }}
            </td>
            <td *ngIf="user.userOfficialDetails == null"></td>
            <td>{{ user.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
  <br />
  <div class="container" id="mainContent">
  <div class="row p-2">
    <div class="col-md-12" style="text-align: center">
      <span class="bg-theme-title">My CTC Details</span>
    </div>
  </div>
  <div class="pb-2" *ngIf="user">
    <div class="col-md-12">
      <table class="table table-striped table-bordered">
        <thead class="">
          <tr>
            <th>CTC</th>
            <th>From Date</th>
            <th>To Date</th>
            <th>Basic</th>
            <th>HRA</th>
            <th>Mobile Allowance</th>
            <th>Conveyance Allowance</th>
            <th>Other Allowances</th>
            <th>Education Allowance</th>
            <th>Child Hostel Allowance</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let userCtc of user.userCtcDetails; index as i"
            id="userCtc_{{ i + 1 }}"
          >
            <td>
              {{
                userCtc.basic +
                  userCtc.hra +
                  userCtc.childHostelAllowance +
                  userCtc.conveyanceAllowance +
                  userCtc.educationAllowance +
                  userCtc.medicalAllowance +
                  userCtc.mobileAllowance
              }}
            </td>
            <td>{{ userCtc.fromDate | date: "dd-MMMM-yyyy" }}</td>
            <td>{{ userCtc.toDate | date: "dd-MMMM-yyyy" }}</td>
            <td>{{ userCtc.basic }}</td>
            <td>{{ userCtc.hra }}</td>
            <td>{{ userCtc.mobileAllowance }}</td>
            <td>{{ userCtc.conveyanceAllowance }}</td>
            <td>{{ userCtc.medicalAllowance }}</td>
            <td>{{ userCtc.educationAllowance }}</td>
            <td>{{ userCtc.childHostelAllowance }}</td>
          </tr>
          <tr *ngIf="user.userCtcDetails.length == 0">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colspan="2">No Records Found</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>